import PropTypes from "prop-types";

export const TextInputFieldPropTypes = {
  inputType: PropTypes.oneOf(["text", "number", "password", "const"]),
  helperText: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  multiline: PropTypes.bool,
  rows: PropTypes.number,
  maxRows: PropTypes.number,
  tooltipData: PropTypes.any,
  tooltipPlacement: PropTypes.oneOf([
    "left",
    "bottom-end",
    "bottom-start",
    "bottom",
    "left-end",
    "left-start",
    "right-end",
    "right-start",
    "right",
    "top-end",
    "top-start",
    "top",
  ]),
  tooltipClass: PropTypes.string,
  autoFocus: PropTypes.bool,
  maxLength: PropTypes.number,
  disablePointerEvents: PropTypes.bool,
  onKeyDown: PropTypes.func,
  onKeyUp: PropTypes.func,
  readOnly: PropTypes.bool,
};
